import { DriverRegistrationLogStatus } from '@gen/partnerDriverWeb/driverRegistrationPortal/models/DriverRegistrationLogStatus';

export const IN_PROGRESS_STATUSES: DriverRegistrationLogStatus[] = [
  DriverRegistrationLogStatus.IN_PROGRESS,
  DriverRegistrationLogStatus.DOCUMENTS_NEED_RESUBMISSION,
];

export const SUBMITTED_STATUSES: DriverRegistrationLogStatus[] = [
  DriverRegistrationLogStatus.SUBMITTED,
  DriverRegistrationLogStatus.DOCUMENTS_RESUBMITTED,
  DriverRegistrationLogStatus.ONBOARDING,
  DriverRegistrationLogStatus.PENDING_COMPANY_APPROVAL,
];

export const ACCEPTED_STATUSES: DriverRegistrationLogStatus[] = [
  DriverRegistrationLogStatus.ACCEPTED,
];

export const DECLINED_STATUSES: DriverRegistrationLogStatus[] = [
  DriverRegistrationLogStatus.DECLINED,
  DriverRegistrationLogStatus.DECLINED_SILENTLY,
];

export const FINAL_STATUSES = [
  ...SUBMITTED_STATUSES,
  ...ACCEPTED_STATUSES,
  ...DECLINED_STATUSES,
];

export const ALLOWED_STATUSES = [...IN_PROGRESS_STATUSES, ...FINAL_STATUSES];
